import React from "react";

const PositioningSection = () => {
  return (
    <div className="bg-[#fff] py-12 md:py-16">
      <div className="max-w-8xl mx-auto px-7 md:px-10 text-center">
        {/* Content */}
        <p className="md:mt-6 mt-4 text-[#6D7380] text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
          In many systems, transaction handling relies on manual checks, loosely defined approvals, or
          centralized control. This creates risk during the most critical moment: when assets are actually
          moving. We replace that with structured frameworks where authorization is distributed,
          execution is predefined, and every step is validated before completion.
        </p>

      </div>
    </div>
  );
};

export default PositioningSection;